// Containers
import UserContainer from '../../containers/UserContainer'
import RoleContainer from '../../containers/RoleContainer'
import ProductContainer from '../../containers/ProductContainer'
import ProductCategoryContainer from '../../containers/ProductCategoryContainer'
import OrderContainer from '../../containers/OrderContainer'
import EnvironmentContainer from '../../containers/EnvironmentContainer'
import BranchContainer from '../../containers/BranchContainer'
import SettingsContainer from '../../containers/SettingsContainer'
import SupportContainer from '../containers/SupportContainer'
import UserSettingsContainer from '../../containers/UserSettingsContainer'
import ShopContainer from '../../containers/ShopContainer'

import DefaultContainer from '../containers/DefaultContainer'
import LimitedSubscriptionContainer from '../containers/LimitedSubscriptionContainer'
import RecurringSubscriptionContainer from '../containers/RecurringSubscriptionContainer'
import EventContainer from '../containers/EventContainer'
import EventWeekTemplateContainer from '../containers/EventWeekTemplateContainer'
import ReportsContainer from '../../containers/ReportsContainer'
import VirtualEventContainer from '../containers/VirtualEventContainer'
import SeasonContainer from '../containers/SeasonContainer'
import LeagueContainer from '../containers/LeagueContainer'

import AddressContainer from '../containers/AddressContainer'
import DistrictContainer from '../containers/DistrictContainer'
import CityContainer from '../containers/CityContainer'
import ParticipantCategoryContainer from '../containers/ParticipantCategoryContainer'
import ParticipantTeamContainer from '../containers/ParticipantTeamContainer'

import TicketTemplateContainer from '../containers/TicketTemplateContainer'
import TicketContainer from '../containers/TicketContainer'

import PromoCodeContainer from '../containers/PromoCodeContainer'

import ContractContainer from '../containers/ContractContainer'
import ContractTemplateContainer from '../containers/ContractTemplateContainer'

import FormContainer from '../containers/FormContainer'
import FormTemplateContainer from '../containers/FormTemplateContainer'

import BinderTemplateContainer from '../containers/BinderTemplateContainer'
import BinderContainer from '../containers/BinderContainer'

// Views
import PasswordRecovery from '../../views/PasswordRecovery'
import NewPassword from '../../views/NewPassword'
import ConfirmPassword from '../../views/ConfirmPassword'
import UserList from '../../views/UserList'
import RoleList from '../../views/RoleList'
import Role from '../../views/Role'
import BranchList from '../../views/BranchList'
import Branch from '../../views/Branch'
import EnvironmentList from '../../views/EnvironmentList'
import Environment from '../../views/Environment'
import Maintenance from '../../views/Maintenance'

import Dashboard from '../views/Dashboard'
import EnvironmentRegister from '../views/EnvironmentRegister'
import Login from '../views/Login'
import User from '../views/User'
import LimitedSubscriptionList from '../views/LimitedSubscriptionList'
import LimitedSubscription from '../views/LimitedSubscription'
import RecurringSubscriptionList from '../views/RecurringSubscriptionList'
import RecurringSubscription from '../views/RecurringSubscription'
import EventList from '../views/EventList'
import Event from '../views/Event'
import EventBookingPanel from '../views/EventBookingPanel'
import EventBooking from '../views/EventBooking'
import EventCalendarPanel from '../views/EventCalendarPanel'
import EventResponsablePanel from '../views/EventResponsablePanel'
import EventMultiBookingPanel from '../views/EventMultiBookingPanel'
import VisitorPanel from '../views/VisitorPanel'
import EventWeekTemplatePanel from '../views/EventWeekTemplatePanel'
import EventWeekTemplateList from '../views/EventWeekTemplateList'
import PurchasePanel from '../views/PurchasePanel'

import Responsables from '../views/Responsable/Responsables'

import VelorailBooking from '../views/VelorailBooking'

import ProductCategoryList from '../views/ProductCategoryList'
import ProductCategory from '../views/ProductCategory'
import ProductList from '../views/ProductList'
import Product from '../views/Product'

import ShopProducts from '../views/Shop/Products'
import ShopProductView from '../views/Shop/ProductView'
import ShopCart from '../views/Shop/Cart'
import ShopCheckout from '../views/Shop/Checkout'
import ShopOptions from '../views/Shop/Options'
import ShopThankYou from '../views/Shop/ThankYou'

import LeagueList from '../views/LeagueList'
import League from '../views/League'

import SeasonList from '../views/SeasonList'
import Season from '../views/Season'

import TicketTemplate from '../views/TicketTemplate'
import TicketTemplateList from '../views/TicketTemplateList'

import TicketList from '../views/TicketList'

import Address from '../views/Address'
import AddressList from '../views/AddressList'
import District from '../views/District'
import DistrictList from '../views/DistrictList'
import City from '../views/City'
import CityList from '../views/CityList'

import ParticipantCategory from '../views/ParticipantCategory'
import ParticipantCategoryList from '../views/ParticipantCategoryList'
import ParticipantTeam from '../views/ParticipantTeam'
import ParticipantTeamList from '../views/ParticipantTeamList'

import SettingsMenu from '../views/Settings/Menu'
import SettingsEnvironment from '../views/Settings/Environment'
import SettingsEvent from '../views/Settings/Event'
import SettingsCommerce from '../views/Settings/Commerce'
import SettingsAccount from '../views/Settings/Account'
import SettingsMessaging from '../views/Settings/Messaging'
import SettingsAutoNotifications from '../views/Settings/AutoNotifications'
import SettingsBooking from '../views/Settings/Booking'
import SettingsIntegrations from '../views/Settings/Integrations'
import SettingsAPI from '../views/Settings/API'
import SettingsImportations from '../views/Settings/Importations'
import SettingsAppearance from '../views/Settings/Appearance'
import SettingsBinder from '../views/Settings/Binder'

import BinderPDFSignature from '../views/BinderPDFSignature'
import BinderPDFStamp from '../views/BinderPDFStamp'

import BinderPDFSignatureList from '../views/BinderPDFSignatureList'
import BinderPDFStampList from '../views/BinderPDFStampList'

import OrderList from '../views/OrderList'
import Order from '../views/Order'

import ReportMenu from '../views/Report/Menu'
import ReportCommercePanel from '../views/Report/Commerce/Panel'
import ReportEventPanel from '../views/Report/Event/Panel'
import ReportSystemPanel from '../views/Report/System/Panel'

import UserRegister from '../views/UserRegister'
import UserProfile from '../views/UserProfile'
import UserSettingsMenu from '../views/UserSettings/Menu'
import UserSettingsAutoNotifications from '../views/UserSettings/AutoNotifications'
import UserSettingsExternalServices from '../views/UserSettings/ExternalServices'
import UserSettingsPaymentMethods from '../views/UserSettings/PaymentMethods'

import VirtualEventRoom from '../views/VirtualEvent/Room'

import MyOrderList from '../views/MyOrderList'
import MyLimitedSubscriptionList from '../views/MyLimitedSubscriptionList'
import MyRecurringSubscriptionList from '../views/MyRecurringSubscriptionList'
import MyContractList from '../views/MyContractList'
import MyContract from '../views/MyContract'
import MyBookingList from '../views/MyBookingList'

import PromoCodeList from '../views/PromoCodeList'
import PromoCode from '../views/PromoCode'

import ContractList from '../views/ContractList'
import Contract from '../views/Contract'
import ContractTemplateList from '../views/ContractTemplateList'
import ContractTemplate from '../views/ContractTemplate'
import ContractPreview from '../views/ContractPreview'

import FormList from '../views/FormList'
import Form from '../views/Form'
import FormTemplateList from '../views/FormTemplateList'
import FormTemplate from '../views/FormTemplate'

import BinderTemplate from '../views/BinderTemplate'
import BinderTemplateList from '../views/BinderTemplateList'

import BinderList from "../views/BinderList";

import BinderPanel from "../views/Binder/Panel";

import SupportMenu from '../views/Support/Menu'
import SupportTicketList from '../views/Support/TicketList'
import SupportTicket from '../views/Support/Ticket'

import Core from '../../core'
import Session from "../../core/session";

window.Core = Core

export default {
    getRoutes() {
        let routes =  [
            {
                path: window.Core.Definition.getDefinition('/maintenance'),
                name: window.Core.Definition.getDefinition('Maintenance'),
                component: Maintenance,
            },
            {
                path: window.Core.Definition.getDefinition('/connexion'),
                name: window.Core.Definition.getDefinition('Connexion'),
                component: Login,
            },
            {
                path: window.Core.Definition.getDefinition('/recuperation-mot-de-passe'),
                name: window.Core.Definition.getDefinition('Récupération du mot de passe'),
                component: PasswordRecovery,
            },
            {
                path: window.Core.Definition.getDefinition('/recuperation-mot-de-passe/:email/:signature'),
                name: window.Core.Definition.getDefinition('Récupération du mot de passe'),
                component: NewPassword,
            },
            {
                path: window.Core.Definition.getDefinition('/confirmation-mot-de-passe/:email/:signature'),
                name: window.Core.Definition.getDefinition('Confirmation du mot de passe'),
                component: ConfirmPassword,
            },
            {
                path: window.Core.Definition.getDefinition('/creation/environnement'),
                name: window.Core.Definition.getDefinition('Création d\'un nouvel environnement'),
                component: EnvironmentRegister,
            },
            {
                path: window.Core.Definition.getDefinition('/creation/environnement/confirmation/:environmentId/:validationKey'),
                name: window.Core.Definition.getDefinition('Création d\'un nouvel environnement'),
                component: EnvironmentRegister,
            },
            {
                path: window.Core.Definition.getDefinition('/inscription'),
                name: window.Core.Definition.getDefinition('Création d\'un nouveau compte client'),
                component: UserRegister,
            },
            {
                path: window.Core.Definition.getDefinition('/inscription/:email'),
                name: window.Core.Definition.getDefinition('Création d\'un nouveau compte client'),
                component: UserRegister,
            },
            {
                path: window.Core.Definition.getDefinition('/contrat/visuel/:accessKey'),
                name: window.Core.Definition.getDefinition('Contrat'),
                component: ContractPreview,
            },
            {
                id: 'dashboard',
                path: '/',
                name: window.Core.Definition.getDefinition('Tableau de bord'),
                redirect: window.Core.Definition.getDefinition('/tableau-de-bord'),
                component: DefaultContainer,
                meta: {
                    caps: [
                        'dashboard_widget_users_activities',
                        'dashboard_widget_active_subscriptions',
                        'dashboard_widget_week_bookings',
                        'dashboard_list_order_overdue',
                        'dashboard_list_limited_subscription_overdue',
                        'dashboard_list_recurring_subscription_overdue',
                        'dashboard_list_limited_subscription_completed',
                        'dashboard_list_recurring_subscription_completed',
                        'dashboard_list_next_bookings',
                        'dashboard_list_next_events',
                        'dashboard_list_my_next_assignations',
                        'dashboard_list_my_next_bookings'
                    ]
                },
                children: [
                    {
                        path: window.Core.Definition.getDefinition('/compte/profil'),
                        name: window.Core.Definition.getDefinition('Mon profil'),
                        component: UserProfile,
                        children: [
                            {
                                path: '/',
                                component: UserSettingsContainer,
                                meta: {
                                    caps: []
                                },
                                children: [
                                    {
                                        path: '/',
                                        component: UserSettingsMenu,
                                        meta: {
                                            caps: []
                                        }
                                    },
                                    {
                                        path: window.Core.Definition.getDefinition('notifications-automatiques'),
                                        name: window.Core.Definition.getDefinition('Notifications automatiques'),
                                        component: UserSettingsAutoNotifications,
                                        meta: {
                                            caps: [
                                            ]
                                        }
                                    },
                                    {
                                        path: window.Core.Definition.getDefinition('services-externes'),
                                        name: window.Core.Definition.getDefinition('Services externes'),
                                        component: UserSettingsExternalServices,
                                        meta: {
                                            caps: [
                                            ]
                                        }
                                    },
                                    {
                                        path: window.Core.Definition.getDefinition('moyens-de-paiements'),
                                        name: window.Core.Definition.getDefinition('Moyens de paiements'),
                                        component: UserSettingsPaymentMethods,
                                        meta: {
                                            caps: [
                                            ]
                                        }
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        path: window.Core.Definition.getDefinition('tableau-de-bord'),
                        component: Dashboard,
                        meta: {
                            caps: [
                                'dashboard_widget_users_activities',
                                'dashboard_widget_active_subscriptions',
                                'dashboard_widget_week_bookings',
                                'dashboard_list_order_overdue',
                                'dashboard_list_limited_subscription_overdue',
                                'dashboard_list_recurring_subscription_overdue',
                                'dashboard_list_limited_subscription_completed',
                                'dashboard_list_recurring_subscription_completed',
                                'dashboard_list_next_bookings',
                                'dashboard_list_next_events',
                                'dashboard_list_my_next_assignations',
                                'dashboard_list_my_next_bookings'
                            ]
                        }
                    },
                    {
                        path: window.Core.Definition.getDefinition('/visiteurs'),
                        name: window.Core.Definition.getDefinition('Visiteurs'),
                        component: VisitorPanel,
                        meta: {
                            caps: []
                        }
                    },
                    {
                        path: window.Core.Definition.getDefinition('/evenement/reservations'),
                        name: window.Core.Definition.getDefinition('Réservations'),
                        component: EventBookingPanel,
                        meta: {
                            caps: []
                        }
                    },
                    {
                        path: window.Core.Definition.getDefinition('/evenement/reserver'),
                        name: window.Core.Definition.getDefinition('Réserver'),
                        component: EventBooking,
                        meta: {
                        }
                    },
                    {
                        path: window.Core.Definition.getDefinition('/velorails/reserver'),
                        name: window.Core.Definition.getDefinition('Réserver'),
                        component: VelorailBooking,
                        meta: {
                        }
                    },
                    {
                        path: window.Core.Definition.getDefinition('/responsables'),
                        name: window.Core.Definition.getDefinition('Responsables'),
                        component: Responsables,
                        meta: {
                        }
                    },
                    {
                        path: window.Core.Definition.getDefinition('/evenements/reserver'),
                        name: window.Core.Definition.getDefinition('Réserver'),
                        component: EventBooking,
                        meta: {
                        }
                    },
                    {
                        path: window.Core.Definition.getDefinition('/evenements/reserver/responsable/:responsableId'),
                        name: window.Core.Definition.getDefinition('Réserver'),
                        component: EventBooking,
                        meta: {
                        }
                    },
                    {
                        path: window.Core.Definition.getDefinition('/evenements/reserver/evenement/:eventId'),
                        name: window.Core.Definition.getDefinition('Réserver'),
                        component: EventBooking,
                        meta: {
                        }
                    },
                    {
                        path: window.Core.Definition.getDefinition('/evenements/reserver/etablissement/:branchId'),
                        name: window.Core.Definition.getDefinition('Réserver'),
                        component: EventBooking,
                        meta: {
                        }
                    },
                    {
                        path: window.Core.Definition.getDefinition('/evenements/reserver/type/:eventType'),
                        name: window.Core.Definition.getDefinition('Réserver'),
                        component: EventBooking,
                        meta: {
                        }
                    },
                    {
                        path: window.Core.Definition.getDefinition('/commerce/boutique'),
                        redirect: '/commerce/boutique/',
                        name: window.Core.Definition.getDefinition('Boutique'),
                        component: ShopContainer,
                        meta: {
                        },
                        children: [
                            {
                                path: window.Core.Definition.getDefinition('/'),
                                component: ShopProducts,
                                meta: {
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('produit/:id'),
                                name: window.Core.Definition.getDefinition('Détails du produit'),
                                component: ShopProductView,
                                meta: {
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('panier'),
                                name: window.Core.Definition.getDefinition('Panier'),
                                component: ShopCart,
                                meta: {
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('confirmation'),
                                name: window.Core.Definition.getDefinition('Confirmation'),
                                component: ShopCheckout,
                                meta: {
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('options'),
                                name: window.Core.Definition.getDefinition('Options'),
                                component: ShopOptions,
                                meta: {
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('merci'),
                                name: window.Core.Definition.getDefinition('Merci'),
                                component: ShopThankYou,
                                meta: {
                                }
                            }
                        ]
                    },
                    {
                        path: window.Core.Definition.getDefinition('/evenement/reservations/:date/:eventDateId'),
                        name: window.Core.Definition.getDefinition('Réservations'),
                        component: EventBookingPanel,
                        meta: {
                            caps: []
                        }
                    },
                    {
                        path: window.Core.Definition.getDefinition('/systeme/utilisateurs'),
                        redirect: window.Core.Definition.getDefinition('/systeme/utilisateurs/'),
                        name: window.Core.Definition.getDefinition('Liste des utilisateurs'),
                        component: UserContainer,
                        meta: {
                            caps: []
                        },
                        children: [
                            {
                                path: '/',
                                component: UserList,
                                meta: {
                                    caps: []
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('nouvel-utilisateur'),
                                name: window.Core.Definition.getDefinition('Nouvel utilisateur'),
                                component: User,
                                meta: {
                                    caps: []
                                }
                            },
                            {
                                path: ':id',
                                name: window.Core.Definition.getDefinition('Modification utilisateur'),
                                component: User,
                                meta: {
                                    caps: []
                                },
                                children: [
                                    {
                                        path: '/',
                                        component: UserSettingsContainer,
                                        meta: {
                                            caps: []
                                        },
                                        children: [
                                            {
                                                path: '/',
                                                component: UserSettingsMenu,
                                                meta: {
                                                    caps: []
                                                }
                                            },
                                            {
                                                path: window.Core.Definition.getDefinition('notifications-automatiques'),
                                                name: window.Core.Definition.getDefinition('Notifications automatiques'),
                                                component: UserSettingsAutoNotifications,
                                                meta: {
                                                    caps: [
                                                    ]
                                                }
                                            },
                                            {
                                                path: window.Core.Definition.getDefinition('services-externes'),
                                                name: window.Core.Definition.getDefinition('Services externes'),
                                                component: UserSettingsExternalServices,
                                                meta: {
                                                    caps: [
                                                    ]
                                                }
                                            },
                                            {
                                                path: window.Core.Definition.getDefinition('moyens-de-paiements'),
                                                name: window.Core.Definition.getDefinition('Moyens de paiements'),
                                                component: UserSettingsPaymentMethods,
                                                meta: {
                                                    caps: [
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        path: window.Core.Definition.getDefinition('/systeme/roles'),
                        redirect: window.Core.Definition.getDefinition('/systeme/roles/'),
                        name: window.Core.Definition.getDefinition('Liste des rôles'),
                        component: RoleContainer,
                        meta: {
                            caps: [
                            ]
                        },
                        children: [
                            {
                                path: '/',
                                component: RoleList,
                                meta: {
                                    caps: []
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('nouveau-role'),
                                name: window.Core.Definition.getDefinition('Nouveau role'),
                                component: Role,
                                meta: {
                                    caps: []
                                }
                            },
                            {
                                path: ':id',
                                name: window.Core.Definition.getDefinition('Modification rôle'),
                                component: Role,
                                meta: {
                                    caps: []
                                }
                            }
                        ]
                    },
                    {
                        path: window.Core.Definition.getDefinition('/systeme/etablissements'),
                        redirect: window.Core.Definition.getDefinition('/systeme/etablissements/'),
                        name: window.Core.Definition.getDefinition('Liste des établissements'),
                        component: BranchContainer,
                        meta: {
                            caps: []
                        },
                        children: [
                            {
                                path: '/',
                                component: BranchList,
                                meta: {
                                    caps: []
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('nouvel-etablissement'),
                                name: window.Core.Definition.getDefinition('Nouvel établissement'),
                                component: Branch,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: ':id',
                                name: window.Core.Definition.getDefinition('Modification établissement'),
                                component: Branch,
                                meta: {
                                    caps: [
                                    ]
                                }
                            }
                        ]
                    },
                    {
                        path: window.Core.Definition.getDefinition('/commerce/produits'),
                        redirect: window.Core.Definition.getDefinition('/commerce/produits/'),
                        name: window.Core.Definition.getDefinition('Liste des produits'),
                        component: ProductContainer,
                        meta: {
                            caps: [
                            ]
                        },
                        children: [
                            {
                                path: window.Core.Definition.getDefinition('categories'),
                                redirect: window.Core.Definition.getDefinition('categories'),
                                name: window.Core.Definition.getDefinition('Liste des catégories de produit'),
                                component: ProductCategoryContainer,
                                meta: {
                                    caps: []
                                },
                                children: [
                                    {
                                        path: '/',
                                        component: ProductCategoryList,
                                        meta: {
                                            caps: [
                                            ]
                                        }
                                    },
                                    {
                                        path: window.Core.Definition.getDefinition('nouvelle-categorie'),
                                        name: window.Core.Definition.getDefinition('Nouvelle catégorie de produit'),
                                        component: ProductCategory,
                                        meta: {
                                            caps: [
                                            ]
                                        }
                                    },
                                    {
                                        path: ':id',
                                        name: window.Core.Definition.getDefinition('Modification de la catégorie de produit'),
                                        component: ProductCategory,
                                        meta: {
                                            caps: [
                                            ]
                                        }
                                    }
                                ]
                            },
                            {
                                path: '/',
                                component: ProductList,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('nouveau-produit'),
                                name: window.Core.Definition.getDefinition('Nouveau produit'),
                                component: Product,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: ':id',
                                name: window.Core.Definition.getDefinition('Modification produit'),
                                component: Product,
                                meta: {
                                    caps: [
                                    ]
                                }
                            }
                        ]
                    },
                    {
                        path: window.Core.Definition.getDefinition('/commerce/codes-promotionnels'),
                        redirect: window.Core.Definition.getDefinition('/commerce/codes-promotionnels/'),
                        name: window.Core.Definition.getDefinition('Liste des codes promotionnels'),
                        component: PromoCodeContainer,
                        meta: {
                            caps: [
                            ]
                        },
                        children: [
                            {
                                path: '/',
                                component: PromoCodeList,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('nouveau-code-promotionnel'),
                                name: window.Core.Definition.getDefinition('Nouveau code promotionnel'),
                                component: PromoCode,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: ':id',
                                name: window.Core.Definition.getDefinition('Modification code promotionnel'),
                                component: PromoCode,
                                meta: {
                                    caps: [
                                    ]
                                }
                            }
                        ]
                    },
                    {
                        path: window.Core.Definition.getDefinition('/commerce/commandes'),
                        redirect: window.Core.Definition.getDefinition('/commerce/commandes/'),
                        name: window.Core.Definition.getDefinition('Liste des commandes'),
                        component: OrderContainer,
                        meta: {
                            caps: [
                            ]
                        },
                        children: [
                            {
                                path: '/',
                                component: OrderList,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('nouvelle-commande'),
                                name: window.Core.Definition.getDefinition('Nouvelle commande'),
                                component: Order,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('nouvelle-commande/:userId'),
                                name: window.Core.Definition.getDefinition('Nouvelle commande'),
                                component: Order,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('nouvelle-commande/:userId/:productId'),
                                name: window.Core.Definition.getDefinition('Nouvelle commande'),
                                component: Order,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: ':id',
                                name: window.Core.Definition.getDefinition('Modification commande'),
                                component: Order,
                                meta: {
                                    caps: [
                                    ]
                                }
                            }
                        ]
                    },
                    {
                        path: window.Core.Definition.getDefinition('/commerce/mes-commandes'),
                        redirect: window.Core.Definition.getDefinition('/commerce/mes-commandes/'),
                        name: window.Core.Definition.getDefinition('Mes commandes'),
                        component: OrderContainer,
                        meta: {
                            caps: [
                            ]
                        },
                        children: [
                            {
                                path: '/',
                                component: MyOrderList,
                                meta: {
                                    caps: [],
                                    displayConditions: {
                                        hasOrders: true
                                    }
                                }
                            }
                        ]
                    },
                    {
                        path: window.Core.Definition.getDefinition('/commerce/abonnements-limites'),
                        redirect: window.Core.Definition.getDefinition('/commerce/abonnements-limites/'),
                        name: window.Core.Definition.getDefinition('Liste des abon. limités'),
                        component: LimitedSubscriptionContainer,
                        meta: {
                            caps: [
                            ]
                        },
                        children: [
                            {
                                path: '/',
                                component: LimitedSubscriptionList,
                                meta: {
                                    caps: []
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('nouvel-abonnement'),
                                name: window.Core.Definition.getDefinition('Nouvel abon. limité'),
                                component: LimitedSubscription,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('nouvel-abonnement/:userId'),
                                name: window.Core.Definition.getDefinition('Nouvel abon. limité'),
                                component: LimitedSubscription,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('nouvel-abonnement/:userId/:productId/:bookingId'),
                                name: window.Core.Definition.getDefinition('Nouvel abon. limité'),
                                component: LimitedSubscription,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: ':id',
                                name: window.Core.Definition.getDefinition('Modification abon. limité'),
                                component: LimitedSubscription,
                                meta: {
                                    caps: [
                                    ]
                                }
                            }
                        ]
                    },
                    {
                        path: window.Core.Definition.getDefinition('/commerce/mes-abonnements-limites'),
                        redirect: window.Core.Definition.getDefinition('/commerce/mes-abonnements-limites/'),
                        name: window.Core.Definition.getDefinition('Mes abonnements limités'),
                        component: LimitedSubscriptionContainer,
                        meta: {
                            caps: [
                            ]
                        },
                        children: [
                            {
                                path: '/',
                                component: MyLimitedSubscriptionList,
                                meta: {
                                    caps: []
                                }
                            }
                        ]
                    },
                    {
                        path: window.Core.Definition.getDefinition('/commerce/mes-contrats'),
                        redirect: window.Core.Definition.getDefinition('/commerce/mes-contrats'),
                        name: window.Core.Definition.getDefinition('Mes contrats'),
                        component: ContractContainer,
                        meta: {
                            caps: [
                            ]
                        },
                        children: [
                            {
                                path: '/',
                                component: MyContractList,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: '/:id',
                                component: MyContract,
                                meta: {
                                    caps: [
                                    ]
                                }
                            }
                        ]
                    },
                    {
                        path: window.Core.Definition.getDefinition('/commerce/abonnements-recurrents'),
                        redirect: window.Core.Definition.getDefinition('/commerce/abonnements-recurrents/'),
                        name: window.Core.Definition.getDefinition('Liste des abon. récurrents'),
                        component: RecurringSubscriptionContainer,
                        meta: {
                            caps: [
                            ]
                        },
                        children: [
                            {
                                path: '/',
                                component: RecurringSubscriptionList,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('nouvel-abonnement'),
                                name: window.Core.Definition.getDefinition('Nouvel abon. récurrent'),
                                component: RecurringSubscription,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('nouvel-abonnement/:userId'),
                                name: window.Core.Definition.getDefinition('Nouvel abon. récurrent'),
                                component: RecurringSubscription,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('nouvel-abonnement/:userId/:productId/:bookingId'),
                                name: window.Core.Definition.getDefinition('Nouvel abon. récurrent'),
                                component: RecurringSubscription,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: ':id',
                                name: window.Core.Definition.getDefinition('Modification abon. récurrent'),
                                component: RecurringSubscription,
                                meta: {
                                    caps: [
                                    ]
                                }
                            }
                        ]
                    },
                    {
                        path: window.Core.Definition.getDefinition('/commerce/mes-abonnements-recurrents'),
                        redirect: window.Core.Definition.getDefinition('/commerce/mes-abonnements-recurrents/'),
                        name: window.Core.Definition.getDefinition('Mes abonnements récurrents'),
                        component: RecurringSubscriptionContainer,
                        meta: {
                            caps: [
                            ]
                        },
                        children: [
                            {
                                path: '/',
                                component: MyRecurringSubscriptionList,
                                meta: {
                                    caps: []
                                }
                            }
                        ]
                    },
                    {
                        path: window.Core.Definition.getDefinition('/contrat/contrats'),
                        redirect: window.Core.Definition.getDefinition('/contrat/contrats'),
                        name: window.Core.Definition.getDefinition('Liste des contrats'),
                        component: ContractContainer,
                        meta: {
                            caps: [
                            ]
                        },
                        children: [
                            {
                                path: '/',
                                component: ContractList,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('nouveau-contrat'),
                                name: window.Core.Definition.getDefinition('Nouveau contrat'),
                                component: Contract,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: ':id',
                                name: window.Core.Definition.getDefinition('Modification contrat'),
                                component: Contract,
                                meta: {
                                    caps: [
                                    ]
                                }
                            }
                        ]
                    },
                    {
                        path: window.Core.Definition.getDefinition('/contrat/gabarits'),
                        redirect: window.Core.Definition.getDefinition('/contrat/gabarits'),
                        name: window.Core.Definition.getDefinition('Liste des gabarits de contrat'),
                        component: ContractTemplateContainer,
                        meta: {
                            caps: [
                            ]
                        },
                        children: [
                            {
                                path: '/',
                                component: ContractTemplateList,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('nouveau-gabarit'),
                                name: window.Core.Definition.getDefinition('Nouveau gabarit'),
                                component: ContractTemplate,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: ':id',
                                name: window.Core.Definition.getDefinition('Modification gabarit'),
                                component: ContractTemplate,
                                meta: {
                                    caps: [
                                    ]
                                }
                            }
                        ]
                    },
                    {
                        path: window.Core.Definition.getDefinition('/formulaire/entrees'),
                        redirect: window.Core.Definition.getDefinition('/formulaire/entrees/'),
                        name: window.Core.Definition.getDefinition('Liste des entrées'),
                        component: FormContainer,
                        meta: {
                            caps: [
                            ]
                        },
                        children: [
                            {
                                path: '/',
                                component: FormList,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('nouvelle-entree/:formTemplateId'),
                                name: window.Core.Definition.getDefinition('Nouvelle entrée'),
                                component: Form,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: ':id',
                                name: window.Core.Definition.getDefinition('Modification entrée'),
                                component: Form,
                                meta: {
                                    caps: [
                                    ]
                                }
                            }
                        ]
                    },
                    {
                        path: window.Core.Definition.getDefinition('/formulaire/gabarits'),
                        redirect: window.Core.Definition.getDefinition('/formulaire/gabarits/'),
                        name: window.Core.Definition.getDefinition('Liste des gabarits de formulaire'),
                        component: FormTemplateContainer,
                        meta: {
                            caps: [
                            ]
                        },
                        children: [
                            {
                                path: '/',
                                component: FormTemplateList,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('nouveau-gabarit'),
                                name: window.Core.Definition.getDefinition('Nouveau gabarit'),
                                component: FormTemplate,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: ':id',
                                name: window.Core.Definition.getDefinition('Modification gabarit'),
                                component: FormTemplate,
                                meta: {
                                    caps: [
                                    ]
                                }
                            }
                        ]
                    },
                    {
                        path: '/commerce/achats',
                        name: window.Core.Definition.getDefinition('Achats'),
                        component: PurchasePanel,
                        meta: {
                            caps: [
                            ]
                        }
                    },
                    {
                        path: '/evenement/nouvelles-reservations',
                        name: window.Core.Definition.getDefinition('Nouvelles réservations'),
                        component: EventMultiBookingPanel,
                        meta: {
                            caps: [
                            ]
                        }
                    },
                    {
                        path: window.Core.Definition.getDefinition('/participant/ligues'),
                        redirect: window.Core.Definition.getDefinition('/participant/ligues/'),
                        name: window.Core.Definition.getDefinition('Liste des ligues'),
                        component: LeagueContainer,
                        meta: {
                            caps: [
                            ]
                        },
                        children: [
                            {
                                path: '/',
                                component: LeagueList,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('nouvelle-ligue'),
                                name: window.Core.Definition.getDefinition('Nouvelle ligue'),
                                component: League,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: ':id',
                                name: window.Core.Definition.getDefinition('Modification de la ligue'),
                                component: League,
                                meta: {
                                    caps: [
                                    ]
                                }
                            }
                        ]
                    },
                    {
                        path: window.Core.Definition.getDefinition('/participant/equipes'),
                        redirect: window.Core.Definition.getDefinition('/participant/equipes/'),
                        name: window.Core.Definition.getDefinition('Liste des équipes'),
                        component: ParticipantTeamContainer,
                        meta: {
                            caps: [
                            ]
                        },
                        children: [
                            {
                                path: '/',
                                component: ParticipantTeamList,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('nouvelle-equipe'),
                                name: window.Core.Definition.getDefinition('Nouvelle équipe'),
                                component: ParticipantTeam,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: ':id',
                                name: window.Core.Definition.getDefinition('Modification de l\'équipe'),
                                component: ParticipantTeam,
                                meta: {
                                    caps: [
                                    ]
                                }
                            }
                        ]
                    },
                    {
                        path: window.Core.Definition.getDefinition('/participant/categories'),
                        redirect: window.Core.Definition.getDefinition('/participant/categories/'),
                        name: window.Core.Definition.getDefinition('Liste des catégories'),
                        component: ParticipantCategoryContainer,
                        meta: {
                            caps: [
                            ]
                        },
                        children: [
                            {
                                path: '/',
                                component: ParticipantCategoryList,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('nouvelle-categorie'),
                                name: window.Core.Definition.getDefinition('Nouvelle catégorie'),
                                component: ParticipantCategory,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: ':id',
                                name: window.Core.Definition.getDefinition('Modification de la catégorie'),
                                component: ParticipantCategory,
                                meta: {
                                    caps: [
                                    ]
                                }
                            }
                        ]
                    },
                    {
                        path: window.Core.Definition.getDefinition('/lieu/adresses'),
                        redirect: window.Core.Definition.getDefinition('/lieu/adresses/'),
                        name: window.Core.Definition.getDefinition('Liste des adresses'),
                        component: AddressContainer,
                        meta: {
                            caps: [
                            ]
                        },
                        children: [
                            {
                                path: '/',
                                component: AddressList,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('nouvelle-adresse'),
                                name: window.Core.Definition.getDefinition('Nouvelle adresse'),
                                component: Address,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: ':id',
                                name: window.Core.Definition.getDefinition('Modification de l\'adresse'),
                                component: Address,
                                meta: {
                                    caps: [
                                    ]
                                }
                            }
                        ]
                    },
                    {
                        path: window.Core.Definition.getDefinition('/lieu/regions'),
                        redirect: window.Core.Definition.getDefinition('/lieu/regions/'),
                        name: window.Core.Definition.getDefinition('Liste des régions'),
                        component: DistrictContainer,
                        meta: {
                            caps: [
                            ]
                        },
                        children: [
                            {
                                path: '/',
                                component: DistrictList,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('nouvelle-region'),
                                name: window.Core.Definition.getDefinition('Nouvelle région'),
                                component: District,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: ':id',
                                name: window.Core.Definition.getDefinition('Modification de la région'),
                                component: District,
                                meta: {
                                    caps: [
                                    ]
                                }
                            }
                        ]
                    },
                    {
                        path: window.Core.Definition.getDefinition('/lieu/villes'),
                        redirect: window.Core.Definition.getDefinition('/lieu/villes/'),
                        name: window.Core.Definition.getDefinition('Liste des villes'),
                        component: CityContainer,
                        meta: {
                            caps: [
                            ]
                        },
                        children: [
                            {
                                path: '/',
                                component: CityList,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('nouvelle-ville'),
                                name: window.Core.Definition.getDefinition('Nouvelle ville'),
                                component: City,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: ':id',
                                name: window.Core.Definition.getDefinition('Modification de la ville'),
                                component: City,
                                meta: {
                                    caps: [
                                    ]
                                }
                            }
                        ]
                    },
                    {
                        path: window.Core.Definition.getDefinition('/billetterie/gabarits'),
                        redirect: window.Core.Definition.getDefinition('/billetterie/gabarits/'),
                        name: window.Core.Definition.getDefinition('Liste des gabarits'),
                        component: TicketTemplateContainer,
                        meta: {
                            caps: [
                            ]
                        },
                        children: [
                            {
                                path: '/',
                                component: TicketTemplateList,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('nouveau-gabarit'),
                                name: window.Core.Definition.getDefinition('Nouveau gabarit'),
                                component: TicketTemplate,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: ':id',
                                name: window.Core.Definition.getDefinition('Modification gabarit'),
                                component: TicketTemplate,
                                meta: {
                                    caps: [
                                    ]
                                }
                            }
                        ]
                    },
                    {
                        path: window.Core.Definition.getDefinition('/billetterie/billets'),
                        redirect: window.Core.Definition.getDefinition('/billetterie/billets/'),
                        name: window.Core.Definition.getDefinition('Liste des billets'),
                        component: TicketContainer,
                        meta: {
                            caps: [
                            ]
                        },
                        children: [
                            {
                                path: '/',
                                component: TicketList,
                                meta: {
                                    caps: [
                                    ]
                                }
                            }
                        ]
                    },
                    {
                        path: window.Core.Definition.getDefinition('/evenement/evenements'),
                        redirect: window.Core.Definition.getDefinition('/evenement/evenements/'),
                        name: window.Core.Definition.getDefinition('Liste des événements'),
                        component: EventContainer,
                        meta: {
                            caps: [
                            ]
                        },
                        children: [
                            {
                                path: '/',
                                component: EventList,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('nouvel-evenement'),
                                name: window.Core.Definition.getDefinition('Nouvel événement'),
                                component: Event,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: ':id',
                                name: window.Core.Definition.getDefinition('Modification événement'),
                                component: Event,
                                meta: {
                                    caps: [
                                    ]
                                }
                            }
                        ]
                    },
                    {
                        path: window.Core.Definition.getDefinition('/evenement/saisons'),
                        redirect: window.Core.Definition.getDefinition('/evenement/saisons/'),
                        name: window.Core.Definition.getDefinition('Liste des saisons'),
                        component: SeasonContainer,
                        meta: {
                            caps: [
                            ]
                        },
                        children: [
                            {
                                path: '/',
                                component: SeasonList,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: ':id',
                                name: window.Core.Definition.getDefinition('Modification saison'),
                                component: Season,
                                meta: {
                                    caps: [
                                    ]
                                }
                            }
                        ]
                    },
                    {
                        path: window.Core.Definition.getDefinition('/evenement/calendrier'),
                        name: window.Core.Definition.getDefinition('Calendrier des événements'),
                        component: EventCalendarPanel,
                        meta: {
                            caps: [
                            ]
                        }
                    },
                    {
                        path: window.Core.Definition.getDefinition('/evenement/mes-reservations'),
                        redirect: window.Core.Definition.getDefinition('/evenement/mes-reservations/'),
                        name: window.Core.Definition.getDefinition('Mes réservations'),
                        component: OrderContainer,
                        meta: {
                            caps: [
                            ]
                        },
                        children: [
                            {
                                path: '/',
                                component: MyBookingList,
                                meta: {
                                    caps: [
                                    ]
                                }
                            }
                        ]
                    },
                    {
                        path: window.Core.Definition.getDefinition('/evenement/salles-virtuelles/:eventDateId'),
                        name: window.Core.Definition.getDefinition('Salle virtuelle'),
                        component: VirtualEventRoom,
                        meta: {
                            caps: [
                            ]
                        }
                    },
                    {
                        path: window.Core.Definition.getDefinition('/evenement/responsables'),
                        name: window.Core.Definition.getDefinition('Responsables'),
                        component: EventResponsablePanel,
                        meta: {
                            caps: [
                            ]
                        }
                    },
                    {
                        path: window.Core.Definition.getDefinition('/evenement/calendrier/modeles'),
                        redirect: window.Core.Definition.getDefinition('/evenement/calendrier/modeles/'),
                        name: window.Core.Definition.getDefinition('Liste des modèles'),
                        component: EventWeekTemplateContainer,
                        meta: {
                            caps: [
                            ]
                        },
                        children: [
                            {
                                path: '/',
                                component: EventWeekTemplateList,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('nouveau-model'),
                                name: window.Core.Definition.getDefinition('Nouveau modèle'),
                                component: EventWeekTemplatePanel,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: ':id',
                                name: window.Core.Definition.getDefinition('Modification modèle'),
                                component: EventWeekTemplatePanel,
                                meta: {
                                    caps: [
                                    ]
                                }
                            }
                        ]
                    },
                    {
                        path: window.Core.Definition.getDefinition('/plateforme/environnements'),
                        redirect: window.Core.Definition.getDefinition('/plateforme/environnements/'),
                        name: window.Core.Definition.getDefinition('Liste des environnements'),
                        component: EnvironmentContainer,
                        meta: {
                            caps: [
                            ]
                        },
                        children: [
                            {
                                path: '/',
                                component: EnvironmentList,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('nouvel-environnement'),
                                name: window.Core.Definition.getDefinition('nouvel environnement'),
                                component: Environment,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: ':id',
                                name: window.Core.Definition.getDefinition('Modification environnement'),
                                component: Environment,
                                meta: {
                                    caps: [
                                    ]
                                }
                            }
                        ]
                    },
                    {
                        path: window.Core.Definition.getDefinition('/outils/rapports'),
                        redirect: window.Core.Definition.getDefinition('/outils/rapports/'),
                        component: ReportsContainer,
                        meta: {
                            caps: []
                        },
                        children: [
                            {
                                path: window.Core.Definition.getDefinition('/'),
                                component: ReportMenu,
                                meta: {
                                    caps: []
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('commerce'),
                                component: ReportCommercePanel,
                                name: window.Core.Definition.getDefinition('Commerce'),
                                meta: {
                                    caps: []
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('evenement'),
                                component: ReportEventPanel,
                                name: window.Core.Definition.getDefinition('Événement'),
                                meta: {
                                    caps: []
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('systeme'),
                                component: ReportSystemPanel,
                                name: window.Core.Definition.getDefinition('Système'),
                                meta: {
                                    caps: []
                                }
                            }
                        ]
                    },
                    {
                        path: window.Core.Definition.getDefinition('/classeur/classeurs'),
                        name: window.Core.Definition.getDefinition('Classeurs'),
                        redirect: window.Core.Definition.getDefinition('/classeur/classeurs/'),
                        component: BinderTemplateContainer,
                        meta: {
                            caps: []
                        },
                        children: [
                            {
                                path: '/',
                                component: BinderTemplateList,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('nouveau-classeur'),
                                name: window.Core.Definition.getDefinition('Nouveau classeur'),
                                component: BinderTemplate,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: ':id',
                                name: window.Core.Definition.getDefinition('Modification classeur'),
                                component: BinderTemplate,
                                meta: {
                                    caps: [
                                    ]
                                }
                            }
                        ]
                    },
                    {
                        path: window.Core.Definition.getDefinition('/classeur/:slug'),
                        component: BinderContainer,
                        meta: {
                            caps: []
                        },
                        children: [
                            {
                                path: '/',
                                component: BinderList,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: ':id',
                                component: BinderPanel,
                                meta: {
                                    caps: [
                                    ]
                                }
                            }
                        ]
                    },
                    {
                        path: window.Core.Definition.getDefinition('/systeme/support'),
                        redirect: window.Core.Definition.getDefinition('/systeme/support/'),
                        name: window.Core.Definition.getDefinition('Support'),
                        component: SupportContainer,
                        meta: {
                            caps: [
                            ]
                        },
                        children: [
                            {
                                path: '/',
                                component: SupportMenu,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('billets'),
                                name: window.Core.Definition.getDefinition('Billets de support'),
                                component: SupportTicketList,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: 'billets/:id',
                                name: window.Core.Definition.getDefinition('Billet de support'),
                                component: SupportTicket,
                                meta: {
                                    caps: [
                                    ]
                                }
                            }
                        ]
                    },
                    {
                        path: window.Core.Definition.getDefinition('/systeme/parametres'),
                        redirect: window.Core.Definition.getDefinition('/systeme/parametres/'),
                        name: window.Core.Definition.getDefinition('Parametres'),
                        component: SettingsContainer,
                        meta: {
                            caps: [
                            ]
                        },
                        children: [
                            {
                                path: window.Core.Definition.getDefinition('/'),
                                component: SettingsMenu,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('evenement'),
                                name: window.Core.Definition.getDefinition('Événement'),
                                component: SettingsEvent,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('importations'),
                                name: window.Core.Definition.getDefinition('Importations'),
                                component: SettingsImportations,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('integrations'),
                                name: window.Core.Definition.getDefinition('Intégrations'),
                                component: SettingsIntegrations,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('reservations'),
                                name: window.Core.Definition.getDefinition('Réservations'),
                                component: SettingsBooking,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('compte-entreprise'),
                                name: window.Core.Definition.getDefinition('Compte entreprise'),
                                component: SettingsAccount,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('messagerie'),
                                name: window.Core.Definition.getDefinition('Messagerie'),
                                component: SettingsMessaging,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('notifications-automatiques'),
                                name: window.Core.Definition.getDefinition('Notifications automatiques'),
                                component: SettingsAutoNotifications,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('environnement'),
                                name: window.Core.Definition.getDefinition('Environnement'),
                                component: SettingsEnvironment,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('evenement'),
                                name: window.Core.Definition.getDefinition('Événements'),
                                component: SettingsAPI,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('apparence'),
                                name: window.Core.Definition.getDefinition('Apparence'),
                                component: SettingsAppearance,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('commerce'),
                                name: window.Core.Definition.getDefinition('Commerce'),
                                component: SettingsCommerce,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('api'),
                                name: window.Core.Definition.getDefinition('API'),
                                component: SettingsAPI,
                                meta: {
                                    caps: [
                                    ]
                                }
                            },
                            {
                                path: window.Core.Definition.getDefinition('classeur'),
                                name: window.Core.Definition.getDefinition('Classeur'),
                                component: SettingsBinder,
                                meta: {
                                    caps: [
                                    ]
                                },
                                children: [
                                    {
                                        path: window.Core.Definition.getDefinition('signatures'),
                                        name: window.Core.Definition.getDefinition('Signatures'),
                                        component: BinderPDFSignatureList,
                                        meta: {
                                            caps: [
                                            ]
                                        },
                                    },
                                    {
                                        path: window.Core.Definition.getDefinition('signatures/nouvelle-signature'),
                                        name: window.Core.Definition.getDefinition('Nouvelle signature'),
                                        component: BinderPDFSignature,
                                        meta: {
                                            caps: [
                                            ]
                                        }
                                    },
                                    {
                                        path: window.Core.Definition.getDefinition('signatures/:id'),
                                        name: window.Core.Definition.getDefinition('Modification signature'),
                                        component: BinderPDFSignature,
                                        meta: {
                                            caps: [
                                            ]
                                        }
                                    },
                                    {
                                        path: window.Core.Definition.getDefinition('etampes'),
                                        name: window.Core.Definition.getDefinition('Étampes'),
                                        component: BinderPDFStampList,
                                        meta: {
                                            caps: [
                                            ]
                                        }
                                    },
                                    {
                                        path: window.Core.Definition.getDefinition('etampes/nouvelle-etampe'),
                                        name: window.Core.Definition.getDefinition('Nouvelle étampe'),
                                        component: BinderPDFStamp,
                                        meta: {
                                            caps: [
                                            ]
                                        }
                                    },
                                    {
                                        path: window.Core.Definition.getDefinition('etampes/:id'),
                                        name: window.Core.Definition.getDefinition('Modification étampe'),
                                        component: BinderPDFStamp,
                                        meta: {
                                            caps: [
                                            ]
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
        return routes
    }
}